/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { createContext, type PropsWithChildren, useContext } from 'react';

import { jsx } from '@compiled/react';

import type { PRODUCT_TYPE } from '../../../common/types';

type ProductContextType = {
	product: PRODUCT_TYPE;
};

const ProductContext = createContext<ProductContextType | null>(null);

type ProductContextProviderProps = PropsWithChildren<{
	product: PRODUCT_TYPE;
}>;

export const ProductContextProvider = ({
	product,
	children,
}: ProductContextProviderProps): JSX.Element => (
	<ProductContext.Provider value={{ product }}>{children}</ProductContext.Provider>
);

export const useProductContext = (): {
	product: string;
} => {
	const context = useContext(ProductContext);
	const defaultContext = {
		product: 'confluence',
	};
	if (!context) {
		// Would be better to throw an error here, but some Confluence packages import this component and don't wrap it in a context provider.
		return defaultContext;
	}

	return context;
};
